
export class ResponseFromRequest {
  title: string;
  subtitle?: string;
  body: string;
  footer?: string;
  type: string;

}

